import React from 'react';
import { CDN_URL } from '@utils/constants/url.constants';
import { ISubjectSubscription } from '@models/interfaces/user.interface';
import {
  subjectCategoryFromId,
  subjectRouteFromId,
} from '@utils/helpers/SubjectParser';
import { useNavigate } from 'react-router-dom';
import { isExpired } from '@components/subscription/store/SubscriptionAtoms';

export interface SubscriptionListItemProps {
  className?: string;
  subscription: ISubjectSubscription;
}

const SubscriptionListItem = ({
  className,
  subscription,
}: SubscriptionListItemProps) => {
  const navigate = useNavigate();

  function getDescription(subs: ISubjectSubscription) {
    let description = '';

    if (isExpired(subs)) {
      description += 'Expired';
    } else if (subs.is_trial_plan) {
      description += 'Trial Version';
    } else {
      // because backend can't change this, we force the VN home edition name
      if (
        subs.currency_code === 'VND' &&
        subs.plan_description === 'Home Edition'
      ) {
        description += 'VN Home Edition';
      } else {
        description += subs.plan_description;
      }
    }

    description +=
      '•' +
      subs.genie_credit +
      ' ' +
      (subs.genie_credit == 1 ? 'worksheet' : 'worksheets');
    return description;
  }

  function getImageUrl() {
    // this is to bypass type checking because of the API returning string instead of integer
    const subjectId = parseInt(subscription.subject_id as unknown as string);

    return `${CDN_URL}assets/images/subject/${subjectCategoryFromId(
      subjectId,
    )}.svg`;
  }

  function handleClickSubscription() {
    // this is to bypass type checking because of the API returning string instead of integer
    const subjectId = parseInt(subscription.subject_id as unknown as string);

    navigate('/subscription/' + subjectRouteFromId(subjectId));
  }

  return (
    <div
      className={
        'p-4 bg-neutral-chalk rounded-2xl shadow-[4px_-4px_0_0_#CFD7E5_inset] relative cursor-pointer overflow-hidden ' +
        (className ?? '')
      }
      onClick={handleClickSubscription}
      data-testid={'list-item'}
    >
      <div className={'flex'}>
        <div className={'flex-grow flex-shrink'}>
          <p
            className={
              'font-bold text-primary-navyblue leading-normal line-clamp-2'
            }
          >
            {subscription.display_name}
          </p>
          <p className={'text-neutral-pencil text-sm'}>
            {getDescription(subscription)}
          </p>
        </div>
        <div className={'flex-shrink-0 flex-grow-0 self-end'}>
          <img className={'ml-4 -mr-4 -mb-3'} src={getImageUrl()} alt={''} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionListItem;
